import { toAbsoluteUrl } from 'app/infrastructure/hosting';
import { FavouriteDataAdapter } from '../../favourite/common/favourite-data-adapter';
import { convertNumericColorToHex, numericColorBrightness } from 'app/infrastructure/universal/color';
import { FavouriteDataColumn } from '../../favourite/common/favourite-interfaces';
import { TableFavouriteModelComponent } from '../table-favourite-model-component';
import { ColumnType } from '../../constants';
import { RegularField } from '../types';
import { DataRow } from './types';

const createOnClickHandler = (model: TableFavouriteModelComponent,
  columns: FavouriteDataColumn[],
  data: DataRow,
  column: number,
  aggregatedColumnIndex?: number
) => {
  if (model.drillDownHandler && (aggregatedColumnIndex !== undefined || columns[column].columnType === ColumnType.aggregation)) {
    return () => model.drillDownHandler.toCaseListing(data.index);
  }
  return undefined;
};

const createUrl = (model: TableFavouriteModelComponent,
  columns: FavouriteDataColumn[],
  data: DataRow,
  column: number
): string => {
  if (model.drillDownHandler && columns[column].urlTemplate) {
    return model.drillDownHandler.toCaseView(data.index, column);
  }
  return undefined;
};

export const mapCell = (dataAdapter: FavouriteDataAdapter,
  model: TableFavouriteModelComponent,
  columns: FavouriteDataColumn[],
  data: DataRow,
  column: number,
  aggregatedColumnIndex?: number
): RegularField => {

  const {
    isAggrColumn: isAggregationColumn,
    uomColIndex: unitOfMeasureColumnIndex
  } = dataAdapter;

  const cellValue = data.row[column];
  const renderAggregatedText = aggregatedColumnIndex !== undefined;

  /**
   * Calculates displayed values
   */
  let textValue = model.format(column, cellValue);
  if (unitOfMeasureColumnIndex >= 0 && isAggregationColumn(columns, column)) {
    textValue += ' ' + model.format(unitOfMeasureColumnIndex, data.row[unitOfMeasureColumnIndex]);
  }

  let aggrValue: string = undefined;
  if (renderAggregatedText) {
    aggrValue = model.format(aggregatedColumnIndex, data.row[aggregatedColumnIndex]);
    if (unitOfMeasureColumnIndex >= 0 && isAggregationColumn(columns, aggregatedColumnIndex)) {
      aggrValue += ' ' + model.format(unitOfMeasureColumnIndex, data.row[unitOfMeasureColumnIndex]);
    }
  }

  /**
   * Calculates tooltip 
   */
  const titleTooltip = model.getTooltip(column);
  let titleAttributeValue: string;
  if (renderAggregatedText) {
    const aggrTitle = model.getTooltip(aggregatedColumnIndex);
    titleAttributeValue = aggrTitle + '\n' + titleTooltip + ':\n' + textValue;
  } else {
    titleAttributeValue = titleTooltip + ':\n' + textValue;
  }

  return {
    tooltip: titleAttributeValue,
    label: model.getHeaderTitle(column),
    value: textValue,
    aggregatedValue: aggrValue,
    onClick: createOnClickHandler(model, columns, data, column, aggregatedColumnIndex),
    url: createUrl(model, columns, data, column),
    iconUrl: cellValue.iconUrl ? toAbsoluteUrl(cellValue.iconUrl) : undefined,
    bgColour: convertNumericColorToHex(cellValue.bgColour),
    bgColourDark: !!cellValue.bgColour && numericColorBrightness(cellValue.bgColour) < 128,
    columnType: columns[column].columnType
  };
};
